import { render, staticRenderFns } from "./CusChatCommon.vue?vue&type=template&id=02321f58&"
import script from "./CusChatCommon.vue?vue&type=script&lang=js&"
export * from "./CusChatCommon.vue?vue&type=script&lang=js&"
import style0 from "./CusChatCommon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02321f58')) {
      api.createRecord('02321f58', component.options)
    } else {
      api.reload('02321f58', component.options)
    }
    module.hot.accept("./CusChatCommon.vue?vue&type=template&id=02321f58&", function () {
      api.rerender('02321f58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/CusChatCommon.vue"
export default component.exports